import { Spinner } from '@change/ds-core-ui';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { HomepagePagePrefetchedDataProps } from 'src/app/pages/homepage/pageContext';
import {
	HomepagePageContextProvider,
	prefetchPageContext,
	prefetchPageUserContext,
} from 'src/app/pages/homepage/pageContext';

import { Layout } from '../layout';

import { HomepageErrorHandler } from './ErrorHandler';

export const Homepage = withPrefetchedData(
	function Homepage({ prefetchedData, prefetchedUserData }: HomepagePagePrefetchedDataProps) {
		return (
			<HomepagePageContextProvider
				prefetchedData={prefetchedData}
				prefetchedUserData={prefetchedUserData}
				errorHandler={HomepageErrorHandler}
				loadingFallback={<Spinner className="mx-auto my-64" />}
			>
				<Layout />
			</HomepagePageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		prefetchData: async (context) => prefetchPageContext(context),
		prefetchUserData: async (context) => prefetchPageUserContext(context),
	},
);
